<template>
    <div ref="slot">
        <slot></slot>
    </div>
    <vue-plyr ref="plyr" :options="options">
        <video controls crossorigin playsinline>
            <source :src="source" type="video/mp4" />
        </video>
    </vue-plyr>
</template>

<script>
export default {
    props: ['source', 'options'],
    mounted() {
        this.$refs.plyr.player.on('play', () => {
            this.$refs.slot.style.pointerEvents = 'none';
            this.$refs.slot.style.display = 'none';
        });
    },
    methods: {
        togglePlay() {
            this.$refs.plyr.player.togglePlay();
        }
    }
};
</script>
